'use client';
import React from 'react';


type SortKey = 'rating' | 'price' | 'reviews';

interface Props {
  sortBy: SortKey;
  onChange: (s: SortKey) => void;
  count: number;
}

const OPTIONS: { key: SortKey; label: string }[] = [
  { key: 'rating', label: '⭐ Rating' },
  { key: 'price', label: '💰 Harga' },
  { key: 'reviews', label: '💬 Populer' },
];

export default function SortControls({ sortBy, onChange, count }: Props) {
  return (
    <div className="flex items-center justify-between mb-4">
      <p className="text-sm text-muted-foreground">
        <span className="font-700 text-foreground font-tabular">{count}</span> tempat ditemukan
      </p>
      <div className="flex items-center gap-1.5 bg-secondary rounded-xl p-1">
        {OPTIONS.map((opt) => (
          <button
            key={`sort-${opt.key}`}
            onClick={() => onChange(opt.key)}
            className={`px-3 py-1.5 rounded-lg text-xs font-600 transition-all ${
              sortBy === opt.key ? 'bg-card text-primary shadow-card' : 'text-muted-foreground hover:text-primary'
            }`}
          >
            {opt.label}
          </button>
        ))}
      </div>
    </div>
  );
}